var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"chat_screen"},[_c('div',{staticClass:"chat_user"},[_vm._v(_vm._s(_vm.chat_room))]),(_vm.chat_room > 0)?_c('client-chat',{attrs:{"clientId":"-1","room_id":_vm.chat_room}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }